import { PermissionString, Role } from "@cervval.js/common-permissions/src/dtos.permissions";
import { PermissionService } from "@cervval.js/common-permissions/src/services/permission.service";


type RolePerEntityId = { [entityId: string]: Role[] };
export type RolePerEntityType = { [entityType: string]: RolePerEntityId };

/** Client-side we can use the ClientAuthenticationService to get the loginData of the current user for permissions checks */
export interface ClientPermissionService<LoginData, PermissionContext, PS extends PermissionString> extends PermissionService<LoginData, PermissionContext, PS> {

    /**
     * build permission context from application environment (usually from a selection service)
     */
    getPermissionContext?: () => PermissionContext;

    /**
     * Same as hasPermission but will use ClientAuthenticationService to get loginData @see {@link hasPermission }
     * and will use getPermissionContext function if no permissionContext is provided
     */
    hasClientPermission(permissions: PermissionString | PermissionString[], permissionContext?: PermissionContext, matchAllPermission?: boolean): boolean;
}